export default function Steps({ steps, activeStep }) {
  const getStatus = (theStep) => {
    if (theStep < activeStep) {
      return 'complete';
    } else if (theStep === activeStep) {
      return 'current';
    } else {
      return 'upcoming';
    }
  };

  return (
    <nav aria-label='Progress'>
      <ol role='list' className='space-y-4 md:flex md:space-y-0 md:space-x-8'>
        {steps.map((step) => (
          <li key={step.name} className='md:flex-1'>
            {getStatus(step.id) === 'complete' ? (
              <button
                type='button'
                onClick={step.onClick}
                className='group w-full flex flex-col border-l-4 border-primary-500 py-2 pl-4 hover:border-primary-500 md:border-l-0 md:border-t-4 md:pl-0 md:pt-4 md:pb-0 text-left'
              >
                <span className='text-sm font-medium text-primary-500 group-hover:text-primary-500'>Step {step.id + 1}</span>
                <span className='text-sm font-medium'>{step.name}</span>
              </button>
            ) : getStatus(step.id) === 'current' ? (
              <button
                type='button'
                onClick={step.onClick}
                className='flex w-full flex-col border-l-4 border-primary-500 py-2 pl-4 md:border-l-0 md:border-t-4 md:pl-0 md:pt-4 md:pb-0 text-left'
                aria-current='step'
              >
                <span className='text-sm font-medium text-primary-500'>Step {step.id + 1}</span>
                <span className='text-sm font-medium'>{step.name}</span>
              </button>
            ) : (
              <button
                type='button'
                onClick={step.onClick}
                className='group w-full flex flex-col border-l-4 border-gray-200 py-2 pl-4 hover:border-gray-300 md:border-l-0 md:border-t-4 md:pl-0 md:pt-4 md:pb-0 text-left'
              >
                <span className='text-sm font-medium text-gray-500 group-hover:text-gray-700'>Step {step.id + 1}</span>
                <span className='text-sm font-medium'>{step.name}</span>
              </button>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
